import { RESET_ALL, RESET_FILTERS, SET_FILTERS, SET_TEAM, SET_TAG_ID } from 'actions/actionTypes';

export function resetFilterAction(sourcePage = 'teamPage') {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch({
        type: RESET_FILTERS,
        sourcePage,
      });
      resolve();
    });
  };
}

// export function addFilterAction(filter, sourcePage = 'teamPage') {
//   return {
//     type: ADD_FILTER,
//     filter,
//     sourcePage
//   };
// }

// export function removeFilterAction(filter, sourcePage = 'teamPage') {
//   return {
//     type: REMOVE_FILTER,
//     filter,
//     sourcePage
//   };
// }

export function setFiltersAction(filters, sourcePage = 'teamPage') {
  return {
    type: SET_FILTERS,
    data: filters,
    sourcePage,
  };
}

export function setTeamAction(teamId, sourcePage = 'teamPage') {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SET_TEAM,
        data: teamId,
        sourcePage,
      });
      resolve();
    });
  };
}

export function setTagAction(tagId, sourcePage = 'teamPage') {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SET_TAG_ID,
        data: tagId,
        sourcePage,
      });
      resolve();
    });
  };
}

export function resetAllAction() {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch({
        type: RESET_ALL,
      });
      resolve();
    });
  };
}
